module.exports = __webpack_public_path__ + "static/img/078.2900d8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/078.png
// module id = 6MBT
// module chunks = 0